const dotenv = require('dotenv');

dotenv.config();

const env = process.env.REACT_APP_ENV || 'dev';

const DEFAULT_BACKEND_SERVER = 'https://9gxf26pc39.execute-api.us-east-1.amazonaws.com/prod';

const server = {
    dev: {
        backend: 'https://9gxf26pc39.execute-api.us-east-1.amazonaws.com/sandbox',
        user_service: 'https://9gxf26pc39.execute-api.us-east-1.amazonaws.com/sandbox',
        refreshTime: 300,
    },
    prod: {
        backend: "https://9gxf26pc39.execute-api.us-east-1.amazonaws.com/prod",
        user_service: "https://9gxf26pc39.execute-api.us-east-1.amazonaws.com/prod",
        refreshTime: 300,
    },
    other: {
        backend: process.env.REACT_APP_BACKEND || DEFAULT_BACKEND_SERVER,
        user_service: process.env.REACT_APP_USER_SERVICE || DEFAULT_BACKEND_SERVER,
        refreshTime: 300
    }
};

export const CONFIG = server[env];

export const REFRESH_TIME = CONFIG.refreshTime;
